export const PASSAGE_READING_TEMPLATES = [
  {
    id: 'business-update',
    pack: 'business',
    title: 'Business Update Reading',
    difficulty: 'Medium',
    duration: 2,
    prompt: 'Read this business update clearly and professionally.',
    passageText: 'Team, I wanted to share an update on our Q3 performance. Revenue grew by 25% compared to last year, exceeding our targets. Customer satisfaction scores have also improved, reaching 4.8 out of 5. Moving forward, we will focus on expanding our product line and entering new markets.',
    wordCount: 45,
    language: 'en',
    category: 'business',
  },
  {
    id: 'quarterly-report',
    pack: 'business',
    title: 'Quarterly Sales Report',
    difficulty: 'Medium',
    duration: 3,
    prompt: 'Present this quarterly report with confidence and clarity.',
    passageText: 'Our Q2 results demonstrate strong momentum across all regions. North America led with 35% growth, followed by EMEA at 28%. The new product launch exceeded expectations with 50,000 units sold in the first month. We anticipate continued acceleration in Q3.',
    wordCount: 48,
    language: 'en',
    category: 'business',
  },
  {
    id: 'customer-service-script',
    pack: 'customer-service',
    title: 'Customer Service Response',
    difficulty: 'Easy',
    duration: 2,
    prompt: 'Read this customer service response with empathy and clarity.',
    passageText: 'Thank you for contacting our support team. I understand how frustrating this issue must be for you, and I sincerely apologize for the inconvenience. Let me assure you that we are taking this matter seriously and working to resolve it as quickly as possible.',
    wordCount: 40,
    language: 'en',
    category: 'customer-service',
  },
  {
    id: 'product-explanation',
    pack: 'customer-service',
    title: 'Product Feature Explanation',
    difficulty: 'Easy',
    duration: 2,
    prompt: 'Explain this product feature in a friendly, helpful manner.',
    passageText: 'Our premium plan includes unlimited cloud storage, priority customer support with 24-hour response time, and advanced analytics dashboards. You can upgrade anytime from your account settings. Would you like me to walk you through the setup process?',
    wordCount: 42,
    language: 'en',
    category: 'customer-service',
  },
  {
    id: 'technical-concept',
    pack: 'technical',
    title: 'Technical Concept Explanation',
    difficulty: 'Hard',
    duration: 3,
    prompt: 'Read this technical explanation as if presenting to a team.',
    passageText: 'API rate limiting is a technique used to control the amount of incoming and outgoing traffic to or from a network. By implementing rate limits, we prevent server overload, ensure fair resource allocation, and protect against malicious attacks such as DDoS.',
    wordCount: 42,
    language: 'en',
    category: 'technical',
  },
  {
    id: 'system-architecture',
    pack: 'technical',
    title: 'System Architecture Overview',
    difficulty: 'Hard',
    duration: 3,
    prompt: 'Present this architecture overview to a technical audience.',
    passageText: 'Our microservices architecture consists of three main layers: the API gateway handles authentication and routing, the service mesh manages inter-service communication, and the data layer uses a combination of PostgreSQL for transactional data and Redis for caching.',
    wordCount: 44,
    language: 'en',
    category: 'technical',
  },
  {
    id: 'general-news',
    pack: 'general',
    title: 'News Article Reading',
    difficulty: 'Easy',
    duration: 2,
    prompt: 'Read this news excerpt clearly and naturally.',
    passageText: 'Scientists have discovered a new species of deep-sea fish near the coast of Australia. The fish, which glows in the dark, was found at depths of over 3,000 meters. Researchers believe there may be hundreds more undiscovered species in this region.',
    wordCount: 41,
    language: 'en',
    category: 'general',
  },
  {
    id: 'story-excerpt',
    pack: 'general',
    title: 'Story Narration',
    difficulty: 'Medium',
    duration: 2,
    prompt: 'Read this story excerpt with appropriate expression.',
    passageText: 'The old lighthouse stood against the storm, its beam cutting through the rain and fog. Maria climbed the spiral staircase, her heart pounding. She had waited twenty years for this moment, and now, with the letter in her hand, she would finally learn the truth.',
    wordCount: 45,
    language: 'en',
    category: 'general',
  },
];

export const PASSAGE_READING_PACKS = [
  { id: 'business', label: 'Business Communication' },
  { id: 'customer-service', label: 'Customer Service' },
  { id: 'technical', label: 'Technical Explanations' },
  { id: 'general', label: 'General Topics' },
];
